"use client";

import { useAuthContext } from "@/context/AuthContext";
import { useRouter } from "next/navigation";
import { User } from "firebase/auth";
import { useEffect } from "react";
import { useCheckUserOrg } from "@/hooks/use-user-check-orgs";
import styles from "../../components/ui/experiments/create-experiments/CreateForm.module.css";

function HomePage() {
  const { user } = useAuthContext() as { user: User };

  const router = useRouter();
  useCheckUserOrg();

  useEffect(() => {
    if (user == null) router.push("/login");
  }, [user, router]);

  useEffect(() => {
    if (user != null) router.push("/batches");
  }, [user, router]);

  return <div className={styles.underConstruction}></div>;
}

export default HomePage;
